import Network from '@/services/network'

export default function handleHotel() {
    const network = new Network;

    const fetchHotelReservationList = (query) => {
        return network.api('get', '/hotel/reservations' + query);
    }

    const fetchPreBookedRoomList = (query) => {
        return network.api('get', '/hotel/reservations/pre-booked' + query);
    }

    const fetchSingleHotelReservation = (query, id) => {
        return network.api('get', `/hotel/reservations/${id}` + query);
    }

    const fetchHotelRoomRates = (query) => {
        return network.api('get', '/hotel/reservations/room-rates' + query);
    }

    const fetchHotelRoomProducts = (query) => {
        return network.api('get', '/hotel/reservations/room-products' + query);
    }

    const fetchHotelRoomAvailability = (query) => {
        return network.api('get', '/hotel/reservations/room-availability' + query);
    }

    const fetchHotelRoomHistory = (query) => {
        return network.api('get', '/hotel/reservations/room-history' + query);
    }

    const updateHotelRoomStatus = (data, roomId) => {
        return network.api('put', `/hotel/reservations/room-status/${roomId}`, data);
    }

    const storeHotelReservation = (data) => {
        return network.api('post', '/hotel/reservations', data);
    }

    const updateHotelReservation = (data, id) => {
        return network.api('put', `/hotel/reservations/${id}`, data);
    }

    const payHotelReservation = (data, id) => {
        return network.api('post', `/hotel/reservations/${id}/pay`, data);
    }

    const cancelHotelReservation = (data, id) => {
        return network.api('post', `/hotel/reservations/${id}/cancel`, data);
    }

    const checkoutHotelReservation = (data, id) => {
        return network.api('post', `/hotel/reservations/${id}/checkout`, data);
    }

    const fetchHotelCheckin = (ipdRegisterId, query) => {
        return network.api('get', `/hotel/checkin/${ipdRegisterId}` + query);
    }

    const addHotelCheckinGuest = (ipdRegisterId, data) => {
        return network.api('post', `/hotel/checkin/${ipdRegisterId}/guests`, data);
    }

    const removeHotelCheckinGuest = (ipdRegisterId, contactProfileId, query) => {
        return network.api('delete', `/hotel/checkin/${ipdRegisterId}/guests/${contactProfileId}` + query);
    }

    const fetchHousekeepingList = (query) => {
        return network.api('get', '/hotel/housekeeping' + query);
    }

    const updateHousekeepingRoom = (data, id) => {
        return network.api('post', `/hotel/housekeeping/${id}`, data);
    }

    return {
        fetchHotelReservationList,
        fetchPreBookedRoomList,
        fetchSingleHotelReservation,
        fetchHotelRoomRates,
        fetchHotelRoomProducts,
        fetchHotelRoomAvailability,
        fetchHotelRoomHistory,
        updateHotelRoomStatus,
        storeHotelReservation,
        updateHotelReservation,
        payHotelReservation,
        cancelHotelReservation,
        checkoutHotelReservation,
        fetchHousekeepingList,
        updateHousekeepingRoom,
        fetchHotelCheckin,
        addHotelCheckinGuest,
        removeHotelCheckinGuest,
    }
}
